import { render, staticRenderFns } from "./CreateKeyModal.vue?vue&type=template&id=5c4956bc&scoped=true"
import script from "./CreateKeyModal.vue?vue&type=script&lang=js"
export * from "./CreateKeyModal.vue?vue&type=script&lang=js"
import style0 from "./CreateKeyModal.vue?vue&type=style&index=0&id=5c4956bc&prod&lang=scss&scoped=true"
import style1 from "./CreateKeyModal.vue?vue&type=style&index=1&id=5c4956bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4956bc",
  null
  
)

export default component.exports